import { Divider, Navbar, NavbarBrand, NavbarContent, NavbarItem } from "@nextui-org/react"

export const Footer = () => {
    return (
        <div className="flex mx-16 lg ">
            <div className="flex h-5 m-4 space-x-4 text-small">
                <div>Terms of Use</div>
                <Divider orientation="vertical" />
                <div>Privacy</div>
                <Divider orientation="vertical" />
                <div>Copyright © 2024 DoxPro Inc.</div>
            </div>
        </div>
    )
}